import { PageInfo } from 'components/Navigation';

export const INIT_PAGE_INFO: PageInfo = {
  page_number: 1,
  page_size: 20,
};
